import {styled} from "@mui/material/styles";
import {Chip} from "@mui/material";

export const StyledChip = styled(Chip)(({theme}) => ({
    marginRight: "1rem",
    marginTop: "1rem",
    color: theme.palette.text.dark,
    backgroundColor: theme.palette.primary.main,
}));